<template>
    <v-dialog
        v-model="$store.state.ckedi.openFuelFreight"
        fullscreen
        transition="dialog-bottom-transition"
        persistent
    >
        <v-container fluid style="padding: 0;overflow: hidden;">
            <v-card>
                <v-toolbar
                    dark
                    color="secondary"
                    dense
                    style="margin-bottom: 15px;"
                >
                    <v-btn
                        icon
                        dark
                        @click="$store.state.ckedi.openFuelFreight = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        CK EDI - Fuel Freight
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-menu
                        v-model="exportMenu"
                        :close-on-content-click="false"
                        :nudge-width="100"
                        offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon dark v-bind="attrs" v-on="on">
                                <v-icon>mdi-file-export</v-icon>
                            </v-btn>
                        </template>

                        <v-card class="mx-auto" max-width="150" tile>
                            <v-list shaped>
                                <v-subheader style="height: 30px;"
                                    >Export To</v-subheader
                                >
                                <v-list-item-group
                                    v-model="selectedReport"
                                    color="primary"
                                    dark
                                >
                                    <v-list-item
                                        v-for="(item, i) in exportOptions"
                                        :key="i"
                                        style="padding: 8px;min-height: unset;"
                                    >
                                        <v-list-item-icon
                                            style="margin: 0 40px 0 6px;"
                                        >
                                            <v-icon
                                                v-text="item.icon"
                                                style="color: #000;"
                                            ></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content
                                            style="padding: 0;"
                                        >
                                            <v-list-item-title
                                                v-text="item.text"
                                                style="font-size: 14px;color: #000;"
                                            ></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>

                            <v-btn
                                color="primary"
                                small
                                style="margin: 6px 10px 10px 10px;"
                                @click="exportDocument"
                            >
                                Export
                            </v-btn>
                        </v-card>
                    </v-menu>
                </v-toolbar>
                <v-row style="margin-top: 20px;justify-content: space-between;">
                    <v-col cols="4" class="header-container">
                        <table class="general-tbl">
                            <caption class="header-title">
                                General File Info
                            </caption>
                            <tr>
                                <th>File ID</th>
                                <td>
                                    {{ FileData.generalFileInfo.EdiFileID }}
                                </td>
                            </tr>
                            <tr>
                                <th>Prefix</th>
                                <td>
                                    {{
                                        FileData.generalFileInfo.FilenamePrefix
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>File Create Datetime</th>
                                <td>{{ FileData.generalFileInfo.FileDttm }}</td>
                            </tr>
                            <tr>
                                <th>Submission Datetime</th>
                                <td>
                                    {{
                                        FileData.generalFileInfo
                                            .FileSubmissionDttm
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>File name</th>
                                <td>
                                    {{
                                        FileData.generalFileInfo.FilenameString
                                    }}
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="7" class="totals-container">
                        <table class="general-tbl">
                            <caption class="header-title">
                                Totals Overview
                            </caption>
                            <tr>
                                <th>Inv Id</th>
                                <th>Inv Date</th>
                                <th>Order Total</th>
                                <th>FSC</th>
                                <th>FSC Amt</th>
                                <th>Subtotal</th>
                                <th>HST</th>
                                <th>TVQ</th>
                                <th colspan="2">Total</th>
                            </tr>
                            <tr>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .InvId
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .InvDate
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .FmtOrderTotal
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .FmtFSC
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .FmtFSCAmount
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .FmtSubTotal
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .FmtHST
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .FmtTVQ
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.invoiceData[0]
                                            .FmtTotal
                                    }}
                                </td>
                                <td class="total-indicator">InvReg</td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td>
                                    {{
                                        FileData.totalsOverview.demFFTotals
                                            .demOrderTotal
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.demFFTotals
                                            .demFSCAvg
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.demFFTotals
                                            .demFSCAmt
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.demFFTotals
                                            .demSubtotal
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.demFFTotals
                                            .demVAT
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.demFFTotals
                                            .demTVQ
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.demFFTotals
                                            .demTotal
                                    }}
                                </td>
                                <td class="total-indicator">
                                    <v-tooltip left>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <p
                                                style="margin: 0;padding: 0;"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                Demurrage Amounts
                                            </p>
                                        </template>
                                        <span>Demurrage Amounts</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td>
                                    {{
                                        FileData.totalsOverview.ffTotals
                                            .OrderTotal
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.ffTotals.FSCAvg
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.ffTotals.FSCAmt
                                    }}
                                </td>
                                <td>
                                    {{
                                        FileData.totalsOverview.ffTotals
                                            .Subtotal
                                    }}
                                </td>
                                <td>
                                    {{ FileData.totalsOverview.ffTotals.VAT }}
                                </td>
                                <td>
                                    {{ FileData.totalsOverview.ffTotals.TVQ }}
                                </td>
                                <td>
                                    {{ FileData.totalsOverview.ffTotals.Total }}
                                </td>
                                <td class="total-indicator">
                                    <v-tooltip left>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <p
                                                style="margin: 0;padding: 0;"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                EDI Calculations
                                            </p>
                                        </template>
                                        <span>EDI Calculations</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td
                                    :style="{
                                        backgroundColor:
                                            FileData.totalsOverview.diffs
                                                .ColorDiffOrderTotal
                                    }"
                                >
                                    {{
                                        FileData.totalsOverview.diffs
                                            .DiffOrderTotal
                                    }}
                                </td>
                                <td
                                    :style="{
                                        backgroundColor:
                                            FileData.totalsOverview.diffs
                                                .ColorDiffFSC
                                    }"
                                >
                                    {{ FileData.totalsOverview.diffs.DiffFSC }}
                                </td>
                                <td
                                    :style="{
                                        backgroundColor:
                                            FileData.totalsOverview.diffs
                                                .ColorDiffFSCAmt
                                    }"
                                >
                                    {{
                                        FileData.totalsOverview.diffs.DiffFSCAmt
                                    }}
                                </td>
                                <td
                                    :style="{
                                        backgroundColor:
                                            FileData.totalsOverview.diffs
                                                .ColorDiffSubtotal
                                    }"
                                >
                                    {{
                                        FileData.totalsOverview.diffs
                                            .DiffSubtotal
                                    }}
                                </td>
                                <td
                                    :style="{
                                        backgroundColor:
                                            FileData.totalsOverview.diffs
                                                .ColorDiffVAT
                                    }"
                                >
                                    {{ FileData.totalsOverview.diffs.DiffVAT }}
                                </td>
                                <td
                                    :style="{
                                        backgroundColor:
                                            FileData.totalsOverview.diffs
                                                .ColorDiffTVQ
                                    }"
                                >
                                    {{ FileData.totalsOverview.diffs.DiffTVQ }}
                                </td>
                                <td
                                    :style="{
                                        backgroundColor:
                                            FileData.totalsOverview.diffs
                                                .ColorDiffTotal
                                    }"
                                >
                                    {{
                                        FileData.totalsOverview.diffs.DiffTotal
                                    }}
                                </td>
                                <td class="total-indicator">
                                    <v-tooltip left>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <p
                                                style="margin: 0;padding: 0;"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                Diff
                                            </p>
                                        </template>
                                        <span
                                            >Diff = (InvReg + Demurrage Amounts)
                                            - EDI Calculations</span
                                        >
                                    </v-tooltip>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">Acceptable Difference</td>
                                <td colspan="8">$0.05</td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 10px;">
                    <v-col cols="12" style="padding: 20px 40px 0;">
                        <table class="general-tbl">
                            <caption class="header-title">
                                Detail Totals
                            </caption>
                            <tr>
                                <th
                                    v-for="(key, k) in detailTotalsHeaders"
                                    :key="k"
                                >
                                    {{ key.key }}
                                </th>
                            </tr>
                            <tr>
                                <td
                                    v-for="(value, v) in detailTotalsHeaders"
                                    :key="v"
                                >
                                    {{ FileData.detailTotals[value.value] }}
                                </td>
                            </tr>
                            <tr>
                                <th
                                    v-for="(key, k) in detailTotalsHeaders2"
                                    :key="k"
                                >
                                    {{ key.key }}
                                </th>
                            </tr>
                            <tr>
                                <td
                                    v-for="(value, v) in detailTotalsHeaders2"
                                    :key="v"
                                >
                                    {{ FileData.detailTotals[value.value] }}
                                </td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 10px;">
                    <v-col cols="12" style="padding: 20px 40px;">
                        <div>
                            <v-toolbar flat style="margin: 10px 0;">
                                <v-row>
                                    <v-col cols="6" style="padding-left: 0;">
                                        <v-toolbar-title
                                            class="header-title"
                                            style=""
                                            >Fuel Freight
                                            Details</v-toolbar-title
                                        >
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="ffDetSearch"
                                            append-icon="mdi-magnify"
                                            label="Search record"
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-switch
                                            v-model="singleExpand"
                                            label="Single expand"
                                            class="mt-2"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                            </v-toolbar>
                            <v-data-table
                                :headers="ffDetailsHeaders"
                                :items="FileData.fuelFreightDetails"
                                :search="ffDetSearch"
                                :single-expand="singleExpand"
                                :expanded.sync="expanded"
                                item-key="EdiFuelFreightID"
                                show-expand
                                fixed-header
                                dense
                            >
                                <template
                                    v-slot:expanded-item="{ headers, item }"
                                >
                                    <td
                                        :colspan="headers.length"
                                        style="background-color: #fff;padding: 0;"
                                    >
                                        <table class="sub-tbl">
                                            <tr>
                                                <th
                                                    v-for="(sub,
                                                    h) in ffDetailsSubHeaders"
                                                    :key="h"
                                                >
                                                    {{ sub.text }}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td
                                                    v-for="(val,
                                                    v) in ffDetailsSubHeaders"
                                                    :key="v"
                                                >
                                                    {{ item[val.value] }}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </template>
                            </v-data-table>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';

export default {
    props: ['FileData'],
    components: {},
    data: function() {
        return {
            exportMenu: false,
            selectedReport: null,
            exportOptions: [
                { text: 'Excel', icon: 'mdi-microsoft-excel' },
                { text: 'EDI FF', icon: 'mdi-file-delimited' }
            ],
            ffDetailsHeaders: [
                { text: '', value: 'data-table-expand', width: '1%' },
                { text: 'Vendor Code', value: 'VendorCode', width: '8%' },
                {
                    text: 'Invoice Number',
                    value: 'InvoiceNumber',
                    width: '15%'
                },
                { text: 'Delivery Date', value: 'DeliveryDate', width: '10%' },
                // { text: 'Invoice Amt', value: 'InvoiceAmount', width: '8%' },
                { text: 'Invoice Amt', value: 'FmtInvoiceAmt', width: '8%' },
                { text: 'TerminalID', value: 'Terminal', width: '7%' },
                { text: 'Terminal Abbr', value: 'TerminalAbbrev', width: '9%' },
                { text: 'BOL', value: 'BillOfLading', width: '5%' },
                { text: 'Site Num', value: 'SiteNumber', width: '7%' },
                // { text: 'VAT (HST)', value: 'ValueAddedTax', width: '7%' },
                { text: 'VAT (HST)', value: 'FmtVAT', width: '7%' },
                // { text: 'TVQ Tax', value: 'UDF04NotInUse', width: '7%' },
                { text: 'TVQ Tax', value: 'FmtTVQ', width: '7%' },
                { text: 'Prod ID', value: 'ProductCode', width: '7%' },
                { text: 'Product', value: 'Product', width: '10%' }
                //{ text: 'Actions', value: 'actions', sortable: false },
            ],
            ffDetailsSubHeaders: [
                // { text: 'Gross Liters', value: 'GrossLitres' },
                { text: 'Gross Liters', value: 'FmtGrossLitres' },
                // { text: 'Net Liters', value: 'NetLitres' },
                { text: 'Net Liters', value: 'FmtNetLitres' },
                // { text: 'Freight Rate', value: 'FreightRate' },
                { text: 'Freight Rate', value: 'FmtFreightRate' },
                // { text: 'Freight Amt', value: 'FreightAmount' },
                { text: 'Freight Amt', value: 'FmtFreightAmt' },
                // { text: 'FSC Rate', value: 'FuelSurchargeRate' },
                { text: 'FSC Rate', value: 'FmtFSCRate' },
                // { text: 'FSC Amt', value: 'FuelSurchargeAmount' },
                { text: 'FSC Amt', value: 'FmtFSCAmt' },
                // { text: 'Split Site', value: 'SplitSite' },
                { text: 'Split Site', value: 'FmtSplitSite' },
                // { text: 'Split Term', value: 'SplitTerminal' },
                { text: 'Split Term', value: 'FmtSplitTerminal' },
                { text: 'Wait Site', value: 'WaitingTimeAtSite' },
                { text: 'Wait Term', value: 'WaitingTimeAtTerminal' },
                // { text: 'Waiting Cost', value: 'WaitingCost' },
                { text: 'Waiting Cost', value: 'FmtWaitingCost' },
                // { text: 'Missing Qty', value: 'MissingQuantity' },
                { text: 'Missing Qty', value: 'FmtMissingQty' },
                // { text: 'No Load', value: 'NoLoad' },
                { text: 'No Load', value: 'FmtNoLoad' },
                // { text: 'Split Retain', value: 'Retain' },
                { text: 'Split Retain', value: 'FmtRetain' },
                // { text: 'Add FSC', value: 'AdditionalFuelSurcharge' },
                { text: 'Add FSC', value: 'FmtAddFSC' },
                // { text: 'Bridge Pass', value: 'BridgePass' },
                { text: 'Bridge Pass', value: 'FmtBridgePass' },
                // { text: 'Milk Run', value: 'MilkRun' },
                { text: 'Milk Run', value: 'FmtMilkRun' },
                // { text: 'Chains', value: 'Chains' },
                { text: 'Chains', value: 'FmtChains' },
                { text: 'Comments', value: 'Comments' },
                // { text: 'Split Diversion', value: 'UDF01Diversion' },
                { text: 'Split Diversion', value: 'FmtUDF01Diversion' },
                // { text: 'Pump Work', value: 'UDF02PumpWork' },
                { text: 'Pump Work', value: 'FmtUDF02PumpWork' },
                // { text: 'Deadhead', value: 'UDF03Deadhead' },
                { text: 'Deadhead', value: 'FmtUDF03Deadhead' }
            ],
            detailTotalsHeaders: [
                { key: 'InvoiceAmtSum', value: 'InvoiceAmtSum' },
                { key: 'VATSum', value: 'VATSum' },
                { key: 'TVQSum', value: 'TVQSum' },
                { key: 'GrossLitersSum', value: 'GrossLitersSum' },
                { key: 'NetLitersSum', value: 'NetLitersSum' },
                { key: 'FreightAmtSum', value: 'FreightAmtSum' },
                { key: 'FSCSum', value: 'FSCSum' },
                { key: 'AddFSCSum', value: 'AddFSCSum' },
                { key: 'SplitSiteSum', value: 'SplitSiteSum' },
                { key: 'SplitTerminalSum', value: 'SplitTerminalSum' }
            ],
            detailTotalsHeaders2: [
                { key: 'WaitingSum', value: 'WaitingSum' },
                { key: 'MissingQtySum', value: 'MissingQtySum' },
                { key: 'NoLoadSum', value: 'NoLoadSum' },
                { key: 'RetainSum', value: 'RetainSum' },
                { key: 'BridgePassSum', value: 'BridgePassSum' },
                { key: 'MilkRunSum', value: 'MilkRunSum' },
                { key: 'ChainsSum', value: 'ChainsSum' },
                { key: 'UDF01DiversionSum', value: 'UDF01DiversionSum' },
                { key: 'UDF02PumpWorkSum', value: 'UDF02PumpWorkSum' },
                { key: 'UDF03DeadheadSum', value: 'UDF03DeadheadSum' }
            ],
            ffDetSearch: '',
            expanded: [],
            singleExpand: true,
            exportDataReady: false,
            exportExcel: {
                data: [],
                filename: ''
            },
            exportEDIFF: ''
        };
    },
    mounted() {
        this.prepareExportData();
    },
    methods: {
        prepareExportData: function() {
            axios
                .post(
                    '/ck-edi/fuel-freight/export-data/prepare',
                    this.FileData.generalFileInfo
                )
                .then(response => {
                    console.log(response.data);
                    this.exportExcel.data = response.data.excel.data;
                    this.exportExcel.filename = response.data.excel.filename;
                    this.exportEDIFF = response.data.ediff;
                    this.exportDataReady = true;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        exportDocument: function() {
            console.log(this.selectedReport);
            if (!this.exportDataReady) {
                this.$store.dispatch('setSnackbar', {
                    color: 'warning',
                    text:
                        'We are still preparing the data for export. Wait a moment.'
                });
                return;
            }

            if (this.selectedReport === 0) {
                // Excel (download document in browser)
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.aoa_to_sheet(
                    this.exportExcel.data
                );
                XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    'CKEDIFuelFreight'
                );
                XLSX.writeFile(workbook, this.exportExcel.filename);

                // Store document in AWS
                const wbOut = XLSX.write(workbook, {
                    bookType: 'xlsx',
                    type: 'array'
                });
                const excelBlob = new Blob([wbOut], {
                    type: 'application/octet-stream'
                });
                const formData = new FormData();
                formData.append('excel', excelBlob, this.exportExcel.filename);
                formData.append(
                    'EdiFileID',
                    this.FileData.generalFileInfo.EdiFileID
                );
                formData.append('Type', 'excel');

                axios
                    .post('/ck-edi/fuel-freight/export-data/store', formData, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            } else if (this.selectedReport === 1) {
                // Validates that the file has not been sent
                if (this.FileData.generalFileInfo.FileSubmissionDttm !== null) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'This file has already been sent.'
                    });
                    return;
                }

                // EDI FF
                const blobEdiff = new Blob([this.exportEDIFF], {
                    type: 'text/plain'
                });
                const formData = new FormData();
                formData.append(
                    'ediff',
                    blobEdiff,
                    this.FileData.generalFileInfo.FilenameString + '.txt'
                );
                formData.append(
                    'EdiFileID',
                    this.FileData.generalFileInfo.EdiFileID
                );
                formData.append('Type', 'ediff');

                // Store document in AWS
                (this.exportMenu = false), (this.$store.state.isLoading = true);
                axios
                    .post('/ck-edi/fuel-freight/export-data/store', formData, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        this.$store.state.isLoading = false;
                        this.$store.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'File successfully exported.'
                        });
                    })
                    .catch(error => {
                        console.error(error);
                    });

                // Download document in browser
                /*
                const url = URL.createObjectURL(blobEdiff);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.FileData.generalFileInfo.FilenameString + '.txt');
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(url);
                document.body.removeChild(link);
                */
            }
        }
    }
};
</script>

<style scoped>
.v-dialog__content--active {
    background-color: rgba(0, 0, 0, 0.7);
}
.v-dialog__content {
    opacity: 0.995;
}
.header-title {
    background-color: #01579b;
    color: #fefeff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 3px 0 3px 15px;
    font-weight: normal;
    font-size: 20px;
    text-align: center;
}
.header-container {
    margin-left: 30px;
    padding-top: 0 !important;
}
.totals-container {
    margin-right: 30px;
    padding-top: 0 !important;
}
.general-tbl {
    border-collapse: collapse;
    width: 100%;
}
.general-tbl th,
.general-tbl td {
    border: 1px solid #dddddd;
    padding: 8px;
    text-align: left;
}
.general-tbl th {
    font-size: 12px;
}
.general-tbl th:hover {
    background-color: #7892b1;
}
.general-tbl td:hover {
    background-color: #e1e1e1;
}
.sub-tbl {
    border-collapse: collapse;
    width: 100%;
}
.sub-tbl th,
.sub-tbl td {
    border: 1px solid #dddddd;
    padding: 8px;
    text-align: left;
}
.sub-tbl th {
    font-size: 12px;
}
.sub-tbl th:hover {
    background-color: #7892b1;
}
.sub-tbl td:hover {
    background-color: #e1e1e1;
}
.total-indicator {
    background-color: #adbbcc;
    font-weight: 700;
    font-size: 12px;
}
.total-indicator:hover {
    background-color: #7892b1 !important;
}
</style>
